import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { District } from '../entities/district';


@Injectable()
export class DistrictService extends BaseCrudService<District>{
    public uri = '/api/district/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance DistrictService');
    }

    buildSentence(entity?: District, event?: LazyLoadEvent): HttpParams {
        let query = '';
        if (entity) {
            query = query.concat(entity.code ? 'code' + QueryOperator.Contain + entity.code + QueryOperator.Split : QueryOperator.Empty);
            query = query.concat(entity.name ? 'name' + QueryOperator.Contain + entity.name + QueryOperator.Split : QueryOperator.Empty);
            const province = entity.province;
            if (province) {
                query = query.concat(province.id ? 'province.id' + QueryOperator.Equal + province.id + QueryOperator.Split : QueryOperator.Empty);
                const department = province.department;
                if (department) {
                    query = query.concat(department.id ? 'province.department.id' + QueryOperator.Equal
                        + department.id + QueryOperator.Split : QueryOperator.Empty);
                    const country = department.country;
                    if (country) {
                        query = query.concat(
                            country.id ? 'province.department.country.id' + QueryOperator.Equal
                            + country.id + QueryOperator.Split : QueryOperator.Empty);
                    }
                }
            }
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/district.service.ts